@import '@hevoio/hevo-ui-toolkit/styles/variables';

.shortcut {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: $font-size-body;
  color: $text-secondary;
}

.textBold + .shortcut {
  margin-left: $spacer * 0.5;
}

.icon {
  font-size: inherit;
  margin-right: 0;
}
